import { TelegramSenderLayout } from "../TelegramSenderLayout";
import { NSARouterMakerResult, NSAVerificationPage } from "namirasoft-account-react";
import { TelegramSenderRouterProps } from "../TelegramSenderRouterProps";
import { useParams } from "react-router-dom";
import { NSBoxString } from "namirasoft-site-react";
import { useRef } from "react";
import { TelegramSenderRoutes } from "../TelegramSenderRoutes";

export interface VerifyBotPageProps extends NSARouterMakerResult, TelegramSenderRouterProps { }

function VerifyBotPage(props: VerifyBotPageProps)
{
	let NSBoxString_ChatID = useRef<NSBoxString>(null);
	let NSBoxString_MessageThreadID = useRef<NSBoxString>(null);

	let { provider_id } = useParams();

	return (
		<TelegramSenderLayout {...props}
			action={{
				title: "Verify Bot",
				description: "Enter the verification code sent to your chat id to confirm your request and activate the service.",
				menus: {}
			}}
		>
			<NSAVerificationPage
				{...props}
				contact_type={"Bot"}
				contact_value_name={"Message"}
				getContactValue={(checkErrors: boolean) =>
				{
					return NSBoxString_ChatID.current?.getValue(checkErrors) ?? "";
				}}
				onRequest={async () =>
				{
					let chat_id = NSBoxString_ChatID.current?.getValue(false) ?? "";
					let message_thread_id = NSBoxString_MessageThreadID.current?.getValue(false) ?? ""
					if (provider_id)
						await props.servers.telegram_sender.provider.Request(provider_id, { chat_id, message_thread_id });
				}}
				onVerify={async code =>
				{
					if (provider_id)
						await props.servers.telegram_sender.provider.Verify(provider_id, { code });
				}}
				onFinished={() =>
				{
					if (provider_id)
						props.url.redirect(TelegramSenderRoutes.ProviderView(provider_id), {});
				}}
			>
				<NSBoxString
					ref={NSBoxString_ChatID}
					title="Chat ID"
					required={false}
					style={{ width: "100%" }}
				/>
				<NSBoxString
					ref={NSBoxString_MessageThreadID}
					title="Message Thread ID"
					required={false}
					style={{ width: "100%" }}
				/>
			</NSAVerificationPage>
		</TelegramSenderLayout>
	);
}

export default VerifyBotPage;